import React, { Component } from 'react';
import { connect } from 'react-redux';
import RCSlider from 'rc-slider';

import throttle from '../../../../util/throttle';

import { handleError, saveConfig, updateTRCScale } from '../../FilterActions';

class ScaleSlider extends Component {
  constructor(props) {
    super(props);

    this.state = {
      scale: 1,
      step: 0.1,
      min: 0.1,
      max: 2,
    };

    this.saveChanges = throttle(this._saveChanges, 1000, this);
  }

  componentDidMount() {
    this.updateState();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.scale !== this.props.scale) {
      this.updateState();
    }
  }

  updateState() {
    this.setState({
      scale: this.props.scale,
    });
  }

  roundToStep(value) {
    const decimals = (String(this.state.step).split('.')[1] || '').length;
    return Number(value.toFixed(decimals));
  }

  decrease = () => {
    let value = this.roundToStep(this.state.scale - this.state.step);
    if (value < this.state.min) {
      return false;
    }

    this.setState({ scale: value });
    this.handleScaleAfterChange(value);
  };

  increase = () => {
    let value = this.roundToStep(this.state.scale + this.state.step);
    if (value > this.state.max) {
      return false;
    }

    this.setState({ scale: value });
    this.handleScaleAfterChange(value);
  };

  handleScaleChange = (e) => {
    this.setState({ scale: e });
  };

  handleScaleAfterChange = (e) => {
    this.props.updateTRCScale(e, this.props.chart);
    this.props.saveConfig();
  };

  // Lucide "chevron-left" / "chevron-right", ISC licence, https://lucide.dev
  renderChevron(path) {
    return (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d={path} />
      </svg>
    );
  }

  render() {
    return (
      <div className="slider-control">
        <div className="slider-values">
          <button
            className="btn slider-step"
            disabled={this.state.scale === this.state.min}
            onClick={this.decrease}
          >
            {this.renderChevron('m15 18-6-6 6-6')}
          </button>
          <span className="slider-value">{`${this.state.scale}`}</span>
          <button
            className="btn slider-step"
            disabled={this.state.scale === this.state.max}
            onClick={this.increase}
          >
            {this.renderChevron('m9 18 6-6-6-6')}
          </button>
        </div>
        <div className="slider-track">
          <RCSlider
            min={this.state.min}
            max={this.state.max}
            step={this.state.step}
            value={this.state.scale}
            onChange={this.handleScaleChange}
            onAfterChange={this.handleScaleAfterChange}
          />
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    handleError: (err) => dispatch(handleError(err, { log: false })),
    saveConfig: () => dispatch(saveConfig()),
    updateTRCScale: (val, chart) => dispatch(updateTRCScale(val, chart)),
  };
};

const mapStateToProps = (state) => {
  let chart = state.filters.chart;
  return {
    chart: state.filters.chart,
    scale: state.filters[chart].scale,
  };
};

const connected = connect(mapStateToProps, mapDispatchToProps)(ScaleSlider);
export { connected as ScaleSlider };
